// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  ITukGetAllAttrs,
  ITukGetAttrs,
  ITukSaveAttrs,
} from 'interfaces/back-office/content-management/tuk/tuk/tuk-view.interface'

const useTuk = () => {
  const {
    contentTuk: {
      contentTuk_isLoading,
      contentTuk_isSaveLoading,
      contentTuk_list,
      contentTuk_detail,
      contentTuk_CLEAR_LIST,
      contentTuk_CLEAR_DETAIL,
      contentTuk_fetchList: contentTukFetchList,
      contentTuk_fetch: contentTukFetch,
      contentTuk_save: contentTukSave,
    },
  } = useStores()

  /**
   * @description Get tuk list
   *
   * @param {ITukGetAllAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const contentTuk_fetchList = useCallback(
    (payload: ITukGetAllAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        contentTukFetchList({
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Get single tuk
   *
   * @param {ITukGetAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const contentTuk_fetch = useCallback(
    (payload: ITukGetAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        contentTukFetch({
          params: payload.params,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Save tuk
   *
   * @param {ITukSaveAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const contentTuk_save = useCallback(
    (payload: ITukSaveAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        contentTukSave({
          params: payload.params,
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    contentTuk_isLoading,
    contentTuk_isSaveLoading,
    contentTuk_list,
    contentTuk_detail,
    contentTuk_CLEAR_LIST,
    contentTuk_CLEAR_DETAIL,
    contentTuk_fetchList,
    contentTuk_fetch,
    contentTuk_save,
  }
}

export { useTuk }
